// extracted by mini-css-extract-plugin
export var dividerLine = "_7n-3";
export var itemImage = "_7n-9";
export var lightDivider = "_7n-4";
export var modalContent = "_7n-5";
export var modalContentCompact = "_7n-6";
export var productCard = "_7n-a";
export var productImage = "_7n-b";
export var productImageCompact = "_7n-7";
export var productImagePlaceholder = "_7n-c";
export var productImagePlaceholderCompact = "_7n-8";
export var progressBarBackground = "_7n-1";
export var progressBarContainer = "_7n-0";
export var progressBarFill = "_7n-2";